




















































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import {sv} from 'vuejs-datepicker/dist/locale';

@Component({components: {Datepicker}})
export default class Presentation extends Vue {
  @Prop() readonly comments!: any;
  @Prop() readonly section!: any;

  showViewPane: boolean = false;
  showEditorPane: boolean = false;

  comment: string = '';

  rows: any = [];

  async mounted() {
    this.comment = this.getComment(this.section.Id);
    this.rows = [
      { Date: '', Text: '' },
      { Date: '', Text: '' },
      { Date: '', Text: '' },
      { Date: '', Text: '' },
      { Date: '', Text: '' },
    ];
    if (this.section.Items) {
      for (let i = 0; i < this.section.Items.length - 5; i++) {
        this.rows.push({ Date: '', Text: '' });
      }
      for (let i = 0; i < this.section.Items.length; i++) {
        const s = this.section.Items[i];
        this.rows[i].Date = s.Date;
        this.rows[i].Text = s.Text;
      }
    }
  }

  addRow() {
    this.rows.push({ Date: '', Text: '' });
  }

  clearText() {
    this.comment = '';
  }

  toggleCommentView() {
    this.showViewPane = !this.showViewPane;
  }

  toggleCommentEdit() {
    if (this.showEditorPane) {
      if (this.getComment(this.section.Id) !== this.comment) {
        this.$emit('comment', {Id: this.section.Id, Comment: this.comment});
      }
    }
    this.showEditorPane = !this.showEditorPane;
    this.$emit('commentPane', this.showEditorPane);
  }

  toggleScheduleEdit() {
    if (this.showEditorPane) {
      if (JSON.stringify(this.storeItems()) !== JSON.stringify(this.rows)) {
        this.$emit('schedule', JSON.parse(JSON.stringify(this.rows)));
      }
    }
    this.showEditorPane = !this.showEditorPane;
    this.$emit('commentPane', this.showEditorPane);
  }

  getComment(id: number) {
    if (!this.comments.Items) {
      return undefined;
    }
    const res = this.comments.Items.find((x: any) => x.Id === id);
    if (res) {
      return res.Comment;
    }
    return undefined;
  }

  storeItems() {
    if (!this.section.Items) {
      return [];
    }
    return this.section.Items;
  }

  get lang() {
    return sv;
  }

  get showComments() {
    return this.comments.ShowComments;
  }

  get showEditor() {
    if (this.section.Type === 'schedule') {
      return false;
    }
    return this.comments.ShowEditor;
  }

  get showScheduleEditor() {
    return this.section.Type === 'schedule';
  }

  get commentHtml() {
    return this.comment.replace('\n', '<br/>');
  }

  get isPrint(): boolean {
    if (!this.$router || !this.$router.currentRoute || !this.$router.currentRoute.name) {
      return false;
    }
    return this.$router.currentRoute.name.endsWith('print');
  }

  get itemCount() {
    return this.rows.length;
  }
}
